import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './styles';

export default function Footer({ ...props }) {
  const { t } = useTranslation();
  return (
    <Container {...props}>
      <div>{t('app:poweredBy')}</div>{' '}
      <div>
        <a href="https://www.w2z.com.br" target="_blank" rel="noopener noreferrer">
          <img src="/images/logo-image.png" width={30} alt="Logo" />
        </a>
      </div>{' '}
      | <div>{t('app:version')}</div>
    </Container>
  );
}
